import { Form, Input } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'

import { useKpi } from '../../../../recoil/view/selectors/kpiFormSelector'

export const KpiFormDescriptionFormItem = ({
  description,
  setDescription,
}: {
  description: string | undefined
  setDescription: (description: string) => void
}): ReactElement => {
  const { setKpi } = useKpi()

  return (
    <>
      <Form.Item label={t(`KPIの説明`)}>
        <Input
          value={description}
          onChange={(event) => {
            setDescription(event.target.value)
          }}
          // onChangeでsetKpiを呼ぶと一文字入力する度に各種Selector等の再計算が走ってしまい
          // 非常に重くなるので更新のタイミングをonBlurにしている
          onBlur={() => {
            setKpi({ description })
          }}
        />
      </Form.Item>
    </>
  )
}
